import { Row, Col } from "reactstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LcaBoxSkeleton = () => {
  return (
    <div className="shadow-sm mb-3" style={{ borderRadius: "0.5rem" }}>
      <Row className="g-0">
        {/* Profile Image Skeleton */}
        <div
          className="position-absolute"
          style={{
            backgroundColor: "white",
            width: "auto",
            padding: "0 3px 3px 0",
            zIndex: 1,
          }}
        >
          <Skeleton
            circle={true} // Circular skeleton for profile photo
            height={20}
            width={20}
          />
        </div>
        {/* Main Image Skeleton (mimicking wc_egcpl-ad) */}
        <Col lg="3" md="3" className="d-flex align-items-center">
          <div
            className="image-container"
            style={{
              overflow: "hidden",
              width: "100%",
              height: "220px",
              borderRadius: "0.5rem",
            }}
          >
            <Skeleton
              height="100%"
              width="100%"
              className="wc_egcpl-ad"
              style={{
                objectFit: "cover",
                borderRadius: "0.25rem",
              }}
            />
          </div>
        </Col>
        <Col lg="7" md="7">
          <div className="p-3">
            <Skeleton
              height={24}
              width="80%"
              style={{ marginBottom: "10px" }}
            />
            <Skeleton count={3} height={16} style={{ marginBottom: "5px" }} />
            <Skeleton height={16} width="50%" style={{ marginBottom: "5px" }} />
            <Skeleton height={16} width="30%" />
          </div>
        </Col>
        <Col
          lg="2"
          md="2"
          className="d-flex flex-column align-items-center justify-content-center"
        >
          <Skeleton height={36} width={100} style={{ marginBottom: "10px" }} />
          <Skeleton height={36} width={100} style={{ marginBottom: "10px" }} />
          <Skeleton height={36} width={100} />
        </Col>
      </Row>
    </div>
  );
};

export default LcaBoxSkeleton;
